interface Config {
  baseUrl: string;
  apiUrl: string;
  frontendUrl?: string;
  encryptionkey?: string;
  PORT?: string;
  photoUrl?: string;
  REACT_APP_STRIPE_PUBLISHABLE_KEY?: string;
  SHUFTIPRO_CLIET_ID?: string;
  SHUFTIPRO_SECRET_KEY?: string;
  SKIP_PHONE_VERIFICATION?: boolean;
  SKIP_DOCUMENT_VERIFICATION?: boolean;
}

const local: Config = {
  baseUrl: "http://localhost:4047/",
  apiUrl: "http://localhost:4047/api/v1",
  frontendUrl: "http://localhost:8080",
  photoUrl: "http://localhost:4047",
  PORT: "",
  REACT_APP_STRIPE_PUBLISHABLE_KEY: "pk_test_51R9mc0CZaTUEMTjEhKD9cJ3ASoYYqf99xDseywWuNfB84ZaIgRU7H0ZNlqM9oBRlh0I8x2IUnGYccXHShgdatlGx00bSk3xe6R",
  SHUFTIPRO_CLIET_ID: "266ecaf1faaa7d7cd3ccf2a220b3290c586fdeeac1738d3b0c5d560b82800822",
  SHUFTIPRO_SECRET_KEY: "Tmva5kHMPzpPa47pfuRir9v4dg0cGxFf",
  SKIP_PHONE_VERIFICATION: true,
  SKIP_DOCUMENT_VERIFICATION: true,
};

const staging: Config = {
  baseUrl: "http://44.211.113.36:4047/",
  apiUrl: "http://44.211.113.36:4047/api/v1",
  frontendUrl: "http://44.211.113.36:4046",
  photoUrl: "http://44.211.113.36:4047/",
  encryptionkey: "",
  PORT: "",
  REACT_APP_STRIPE_PUBLISHABLE_KEY: "pk_test_51R9mc0CZaTUEMTjEhKD9cJ3ASoYYqf99xDseywWuNfB84ZaIgRU7H0ZNlqM9oBRlh0I8x2IUnGYccXHShgdatlGx00bSk3xe6R",
  SHUFTIPRO_CLIET_ID: "266ecaf1faaa7d7cd3ccf2a220b3290c586fdeeac1738d3b0c5d560b82800822",
  SHUFTIPRO_SECRET_KEY: "Tmva5kHMPzpPa47pfuRir9v4dg0cGxFf"

};

const production: Config = {
  baseUrl: "https://lendriva.com/",
  apiUrl: "https://lendriva.com/api/v1",
  frontendUrl: "https://lendriva.com",
  photoUrl: "https://lendriva.com/",
  encryptionkey: "",
  PORT: "80",
  REACT_APP_STRIPE_PUBLISHABLE_KEY: "pk_test_51R9mc0CZaTUEMTjEhKD9cJ3ASoYYqf99xDseywWuNfB84ZaIgRU7H0ZNlqM9oBRlh0I8x2IUnGYccXHShgdatlGx00bSk3xe6R",
  SHUFTIPRO_CLIET_ID: "266ecaf1faaa7d7cd3ccf2a220b3290c586fdeeac1738d3b0c5d560b82800822",
  SHUFTIPRO_SECRET_KEY: "Tmva5kHMPzpPa47pfuRir9v4dg0cGxFf"
};

let envConfig: Config;

if (process.env.NODE_ENV === "development") {
  envConfig = local;
} else if (process.env.NODE_ENV === "none") {
  envConfig = staging;
} else if (process.env.NODE_ENV === "production") {
  envConfig = production;
} else {
  envConfig = local;
}

export default envConfig;
